import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import InputField from '../../../../../helpers/Fields/InputField';
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { createQuestionSubject, updateQuestionSubject } from '../../../../actions';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      hasPassoword: props.initialValues.password
    }
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose} = this.props;

      if(values.id){
        await this.props.updateQuestionSubject(values);
        toastr.success(formatMessage('msgNotificationTitleQuestionSubjectCreaded'), formatMessage('msgNotificationQuestionSubjectCreated'))

      } else {
        await this.props.createQuestionSubject(values);
        toastr.success(formatMessage('msgNotificationTitleQuestionSubjectUpdated'), formatMessage('msgNotificationQuestionSubjectUpdated'))
      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, valuesForm } = this.props;
    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='name'
          label={formatMessage('txtCaptionQuestionSubject')}
          component={InputField}
          validate={[required()]}
        />
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelQuestionSubject')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateQuestionSybject': 'btnModalUpdateQuestionSubject')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_subject',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_subject')(state)
})

const mapDispatchToProps = {
  createQuestionSubject,
  updateQuestionSubject,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Subject/components/FormModal/FormContent.jsx